const esportes = [
    {
        nome : 'Ciclismo',
        icon : 'mdi-bike',
        medida : 'Km/h',
    },
    {
        nome : 'Corrida',
        icon : 'mdi-run',
        medida : 'min/Km',
    },
    {
        nome : 'Natação',
        icon : 'mdi-swim',
        medida : 'min/100m',
    },

]

export default {
    ESPORTES: esportes,
}
